import React from "react";
import Script from "next/script";

const ASSET_HOST = process.env.NEXT_PUBLIC_ASSET_HOST;
const PLUG_SCRIPT_SRC = `//${ASSET_HOST}/s3/fence/plug-client/v0/app.bundle.js`;

// Plug is only initialized once
let initialized = false;

export function initPlug() {
    return () => {
        if (
            !initialized &&
            typeof window !== "undefined" &&
            window.plugClient
        ) {
            window.plugClient.init({});
            initialized = true;
        }
    };
}

export function PlugScript() {
    return (
        <Script
            src={PLUG_SCRIPT_SRC}
            id="plug-client-snippet"
            onReady={initPlug()}
        />
    );
}
